<template>
  <div>
    <h1>
      {{ $t("booking.booking") }} {{ booking.reservation_number }} <v-chip>{{ booking.name }}</v-chip>
    </h1>

    <!--    <v-layout class="flight-header" row wrap>-->
    <!--      <v-flex class="header-flight-part-block flight-part" white xs6>-->
    <!--    <h1>{{ booking.name }}</h1>-->
    <!--      </v-flex>-->
    <!--    </v-layout>-->

    <h2 class="mt-3">{{ $t("booking.passengers") }}</h2>
    <!-- eslint-disable-next-line -->
    <div v-for="passenger in booking.passengers">
      <fieldset class="pd-1 custom-fieldset">
        <v-row>
          <v-col class="text-center align-content-center fill-height align-content-center" md="1" cols="1">
            <v-icon style="font-size: 46px; color: rgba(0, 0, 0, 0.32);">fa-user-circle</v-icon>
          </v-col>
          <v-col cols="5">
            <v-text-field :label="$t('booking.passenger')" :value="passenger" class="no-line-after-input" disabled> </v-text-field>
          </v-col>
        </v-row>
      </fieldset>
    </div>

    <template v-if="$store.getters.hasPermission('viewInvoices')">
      <h2>{{ $t("global.invoice") }}</h2>

      <span v-if="booking.invoices.length === 0">
        {{ $t("booking.invoiceNotSet") }}
      </span>

      <span v-else v-for="invoice of booking.invoices" :key="invoice.id">
        <v-row>
          <v-col class="text-center align-content-center fill-height align-content-center" md="1" cols="1">
            <v-icon style="font-size: 46px; color: rgba(0, 0, 0, 0.32);">mdi-file-document</v-icon>
          </v-col>
          <v-col md="3" cols="5">
            <v-text-field :label="$t('invoice.details.invoiceNumber')" :value="invoice.number" class="no-line-after-input" disabled />
          </v-col>
          <v-col md="7" cols="12">
            <v-row v-for="invoiceItem of invoice.items" :key="invoiceItem.id">
              <v-text-field
                :label="$t('booking.other.serviceName')"
                class="no-line-after-input"
                disabled
                :value="invoiceItem.name + ' ' + invoiceItem.gross_in_currency + ' ' + invoiceItem.currency"
              />
            </v-row>
          </v-col>
          <v-spacer />
          <v-col class="text-right" cols="1">
            <v-btn :to="'/invoices/details/' + invoice.id" icon>
              <v-icon>remove_red_eye</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </span>
    </template>
  </div>
</template>

<script>
import dayOfWeek from "../../repository/shortDayOfWeekFromDate";
import filterOverAllProperty from "../../repository/filterOverAllProperty";
import getTextDateDiff from "../../repository/getTextDateDiff";
import Booking from "../../models/booking/booking";
import formatDateView from "../../repository/fotmatDateView";

export default {
  name: "BookingFlightDetailView",
  data: () => ({
    search: "",
    booking: new Booking()
  }),
  computed: {
    travelTimeFirstPart() {
      let startDateTime = this.booking.start_date + " " + this.booking.start_time;
      let endDateTime = this.booking.end_date + " " + this.booking.end_time;
      return getTextDateDiff(startDateTime, endDateTime);
    },
    travelTimeSecondPart() {
      let startDateTime = this.booking.return_start_date + " " + this.booking.return_start_time;
      let endDateTime = this.booking.return_end_date + " " + this.booking.return_end_time;
      return getTextDateDiff(startDateTime, endDateTime);
    },
    travelTransfersFirstPart() {
      return this.booking.routes.filter(route => route.is_return_route === 0).length - 1;
    },
    travelTransfersSecondPart() {
      return this.booking.routes.filter(route => route.is_return_route === 1).length - 1;
    }
  },
  methods: {
    viewBooking: function(booking) {
      this.$store.dispatch("Booking/loadBookingDetails", booking);
    },
    dayOfWeek: dayOfWeek,
    filterOverAllProperty: filterOverAllProperty,
    formatDateView: formatDateView
  },
  created() {
    if (typeof this.$route.params.id !== "undefined") {
      this.booking.load(this.$route.params.id);
    }
  },
  mounted() {
    //this.$store.dispatch("Visual/setHalfBackground");
  },
  beforeDestroy() {
    //this.$store.dispatch("Visual/setWhiteBackground");
  }
};
</script>

<style scoped>
.chip--small {
  height: 22px;
}

.flight-direction {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.grey--text {
  color: #9e9e9e !important;
}

.bigger {
  margin-right: 4px;
  font-size: 15px;
}

.flight-airport {
  font-weight: 700;
  line-height: 1;
  font-size: 16px;
}

.header-flight-part-block {
  background-color: white;
  margin-left: 15px;
  margin-right: 15px;
  padding: 15px;
  box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);
}

.header-flight-icon {
  padding: 0 30px;
  font-size: 50px;
}

.flight-airport > .bigger {
  font-size: 24px;
}

.flight-header {
  margin-top: 30px;
  margin-bottom: 75px;
}

.flight-divider {
  font-weight: 700;
  position: relative;
  top: -11px;
}

.flight-divider-text {
  text-transform: uppercase;
}

.flight-content {
  font-size: 24px;
  font-weight: 700;
}

.flight-content-airport-code {
  font-size: 18px;
}

.flight-content-airport-name {
  color: #909194;
}

.flight-content-time {
}

.dot {
  position: relative;
  /*top: -3px;*/
  /*left: 50%;*/
  width: 6px;
  height: 6px;
  background-color: #44d3af;
  border-radius: 50%;
  display: inline-block;
  margin: 0 20px;
}

.dot-container {
  height: 6px;
  margin-bottom: 10px;
}

.route-line {
  top: 12px;
  position: relative;
}

.v-expansion-panels {
  box-shadow: none;
}

.upper-line {
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>

<style>
.pa-0 > .v-expansion-panel__header {
  padding: 0 !important;
}
</style>
